import { api } from "./configs/axiosConfigs";

export const AllianceAPI = {
  getAlliances: async () => {
    const response = await api
      .get("/alliance")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  getAlliancesSearch: async (term) => {
    const response = await api
      .get(`/alliance?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  createAlliance: async (data: any) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("description", data.description || "");
    formData.append("region_id", data.region_id || "");
    formData.append("region", data.region || "");
    formData.append("type", data.type);
    if (data.type === "Estratégica") {
      formData.append("order", String(data.order));
      if (data.logo instanceof File) {
        formData.append("logo", data.logo);
      }
    }
    formData.append("status", data.status);
    const response = await api.post("/alliance", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  editAlliance: async (id: number, data: any) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("description", data.description || "");
    formData.append("region_id", data.region_id || "");
    formData.append("region", data.region || "");
    formData.append("type", data.type);
    if (data.type === "Estratégica") {
      if (data.order !== undefined) {
        formData.append("order", String(data.order));
      }
      if (data.logo instanceof File) {
        formData.append("logo", data.logo);
      }
    }
    formData.append("status", data.status);
    const response = await api.post(`/alliance/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  deleteAlliance: async (id: number) => {
    const response = await api
      .delete(`/alliance/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return error.response.data;
      });
    return response;
  },

  getRegions: async () => {
    const response = await api
      .get("/region")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
};